<template>
  <div class="attent-item">
    <van-list
      class="vant-list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      @load="onLoad"
    >
      <div class="item" v-for="(item, index) in attents" :key="item.id">
        <van-image round class="avatar" fit="cover" :src="item.headimgurl" />
        <div class="info">
          <div class="name">{{ item.nickname }}</div>
          <div class="sign">等级：{{ item.level_msg }}</div>
        </div>
        <div class="follow" @click="followClick(index)">
          {{ getIsFollow(index) }}
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { userFollow, userUnFollow } from "network/home";

export default {
  name: "AttentItem",
  components: {},
  props: {
    attents: Array,
  },
  data() {
    return {
      loading: false,
      finished: false,
    };
  },
  computed: {
    getIsFollow() {
      return (index) => {
        console.log(index);
        return this.attents[index].is_followed ? "已关注" : "+关注";
      };
    },
  },
  created() {},
  mounted() {},
  methods: {
    //关注或取消关注
    followClick(index) {
      let params = { user_id: this.attents[index].id };
      if (this.attents[index].is_followed) {
        userUnFollow(qs.stringify(params)).then((res) => {
          this.attents[index].is_followed = !this.attents[index].is_followed;
        });
      } else {
        userFollow(qs.stringify(params)).then((res) => {
          this.attents[index].is_followed = !this.attents[index].is_followed;
        });
      }
    },
    //加载更多
    onLoad() {
      console.log(1111112);
      this.$emit("loadMore", (loading) => {
        this.loading = loading;
        if (loading == true) {
          this.finished = true;
        }
      });
    },
  },
  watch: {},
};
</script>
<style scoped>
.attent-item {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 10px;
}
.vant-list {
  min-height: 300px;
}
.item {
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
}
.avatar {
  width: 60px;
  height: 60px;
  border: 1px solid #707070;
}
.info {
  margin-left: 15px;
}
.info .name {
  margin-bottom: 3px;
  font-size: 14px;
  font-weight: 600;
  color: #232323;
}
.info .sign {
  margin-top: 3px;
  width: 150px;
  font-size: 13px;
  color: #232323;
}
.follow {
  width: 60px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  border-radius: 5px;
  background-color: var(--color-main);
  font-size: 14px;
  color: #fff;
}
</style>